if (!customElements.get('nr-cinematic-film')) {
  customElements.define('nr-cinematic-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 699px)');
      this.wantsPlayback = !this.reduced.matches;
      this.inView = false;
      this.video.addEventListener('playing', () => {
        if (!this.wantsPlayback || !this.inView || document.hidden || this.video.paused) {
          this.video.pause();
          return;
        }
        this.classList.add('is-playing');
      }, options);
      this.video.addEventListener('error', () => {
        this.classList.remove('is-playing');
        this.wantsPlayback = false;
      }, options);
      this.reduced.addEventListener('change', () => {
        this.wantsPlayback = !this.reduced.matches;
        if (this.reduced.matches) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.classList.remove('is-playing');
        }
        this.sync();
      }, options);
      this.mobile.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.05 });
      this.observer.observe(this);
    }
    sync() {
      if (!this.wantsPlayback || !this.inView || document.hidden) {
        this.video.pause();
        return;
      }
      const source = this.mobile.matches && this.dataset.mobile ? this.dataset.mobile : this.dataset.desktop;
      if (this.video.getAttribute('src') !== source) {
        this.classList.remove('is-playing');
        this.video.src = source;
        this.video.muted = true;
        this.video.load();
      }
      this.video.play().catch(error => {
        if (error.name !== 'AbortError') {
          this.wantsPlayback = false;
        }
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}
